const getNumberBetween = (s: number, e: number) => {
  const diff = e - s;
  return s + Math.ceil(Math.random() * diff);
};

export default getNumberBetween;
